var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuantityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85244 0H12.1393C15.1742 0 16.9918 1.95143 17 5.20971V14.7903C17 18.0486 15.1906 20 12.1476 20H9.44993C9.10397 19.959 8.84211 19.6452 8.84211 19.2715C8.84211 18.8978 9.10397 18.584 9.44993 18.543H12.1393C14.4586 18.543 15.6265 17.2804 15.6265 14.7903V5.20971C15.6265 2.71965 14.4586 1.45695 12.1393 1.45695H4.85244C2.53314 1.45695 1.35704 2.71965 1.35704 5.20971V14.7903C1.35704 17.2804 2.53314 18.543 4.85244 18.543C5.1984 18.584 5.46026 18.8978 5.46026 19.2715C5.46026 19.6452 5.1984 19.959 4.85244 20C1.81761 20 0 18.0486 0 14.7903V5.20971C0 1.9426 1.81761 0 4.85244 0ZM5.09093 6.49895H7.68164C8.0276 6.45799 8.28946 6.14415 8.28946 5.77047C8.28946 5.39679 8.0276 5.08295 7.68164 5.04199H5.09093C4.74497 5.08295 4.48311 5.39679 4.48311 5.77047C4.48311 6.14415 4.74497 6.45799 5.09093 6.49895ZM11.8925 10.7285H5.09085H5.08263C4.73667 10.6875 4.47481 10.3737 4.47481 10C4.47481 9.62632 4.73667 9.31247 5.08263 9.27152H11.8925C12.1527 9.24071 12.4065 9.37243 12.5456 9.61057C12.6847 9.8487 12.6847 10.1513 12.5456 10.3894C12.4065 10.6276 12.1527 10.7593 11.8925 10.7285ZM11.8927 14.9581H5.09104H5.08281C4.71035 14.9581 4.40841 14.634 4.40841 14.2341C4.40841 13.8342 4.71035 13.51 5.08281 13.51H11.8927C12.2651 13.51 12.5671 13.8342 12.5671 14.2341C12.5671 14.634 12.2651 14.9581 11.8927 14.9581Z",
    fill: "#FC2B6E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantityIcon);
export default __webpack_public_path__ + "static/media/QuantityIcon.565ddf14c3c2fecb511a86e4284e2d2e.svg";
export { ForwardRef as ReactComponent };